module.exports = __webpack_public_path__ + "img/logo-title.ae144fcc.png";